import {
	type CheckboxProps,
	Checkbox as PaperCheckbox,
} from "react-native-paper";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";

export const Checkbox = ({ status, ...props }: CheckboxProps) => {
	const theme = useAppTheme();
	return (
		<Box style={{ opacity: props.disabled ? 0.38 : 1 }}>
			<PaperCheckbox.Android
				{...props}
				status={status}
				uncheckedColor={
					status === "indeterminate"
						? theme.colors.primary
						: theme.colors.onSurfaceVariant
				}
			/>
		</Box>
	);
};
